module.exports = __webpack_public_path__ + "static/JL.190207.COH.WEBW.Gallery4-e79524a611adb66c49d2c8b0dc886459.jpg";